// This file is evil and should go away.
// Global state that has to run at the right point in time has created lots of issues in the past.
// Please do not add to this file but only remove things.
var legacyGlobal = {
	currentlyActiveTabPopup: undefined,
	toplevelElement: undefined,
	isIE: (new RegExp("MSIE (\\d+)\\.(\\d+)", "i").exec(navigator.appVersion) != null),
	isIE6: (new RegExp("MSIE 6\\.(\\d+)", "i").exec(navigator.appVersion) != null),
	isIE7: (new RegExp("MSIE 7\\.(\\d+)", "i").exec(navigator.appVersion) != null),
	isIE8: (new RegExp("MSIE 8\\.(\\d+)", "i").exec(navigator.appVersion) != null),
	isIE9: (new RegExp("MSIE 9\\.(\\d+)", "i").exec(navigator.appVersion) != null),
	isIE10: (new RegExp("MSIE 10\\.(\\d+)", "i").exec(navigator.appVersion) != null),
	isIE11: (new RegExp("MSIE 11\\.(\\d+)", "i").exec(navigator.appVersion) != null),
	isOpera: /Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent),
	isFirefox: /Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent),
	isChrome: navigator.userAgent.toLowerCase().indexOf('chrome') > -1,
	isIPad: (navigator.userAgent.match(/iPad/i) != null),
	isIPhone: (navigator.userAgent.match(/iPhone/i) != null),
	portal: "classic",
	cloudComputeCalls: 0,
	controls: {},

	getToplevelElement: function() {
		if (!legacyGlobal.toplevelElement) {
			legacyGlobal.toplevelElement = document.body.querySelector('form');
			if (!legacyGlobal.toplevelElement)
				legacyGlobal.toplevelElement = document.body;
		}
		return legacyGlobal.toplevelElement;
	},

	getControlPromise: function(clazz) {
		// The legacy controls are made available by the entrypoint.ts by assigning
		// them as global variables to window.
		// Execution of the related code paths happens asynchronously, but for
		// things to work, we need to be sure that the legacy code has been
		// imported.
		// Here, we register a promise that we can await and that will resolve,
		// once the control has been assigned.
		if (legacyGlobal.controls[clazz] === undefined) {
			control = {};
			control.control = new Promise((resolve) => control.resolve = resolve);
			legacyGlobal.controls[clazz] = control;
		}
		return legacyGlobal.controls[clazz];
	},

	DOMReadyConstruct: function(clazz, el, options) {
		jQuery(document).ready(function() {
			const promise = legacyGlobal.getControlPromise(clazz).control;
			promise.then((control) => {
				new control(el, options);
			})
		})
	},

	DOMReadyActions: function() {
		legacyGlobal.toplevelElement = document.body.querySelector('form');

		if (!legacyGlobal.toplevelElement)
			legacyGlobal.toplevelElement = document.body;

		legacyGlobal.window = new Window(window);

		document.dispatchEvent(new CustomEvent("document:allSet"));
	},

	// scales the window depending on the width of the window
	// works only for chrome so far
	scaleScreen: function() {

		var val = window.innerWidth / 1280.0;

		var b = document.getElementsByTagName("html")[0];

		b.setAttribute("style", "zoom: " + val + ";");

	},

	onLoadActions: function() {
		window.removeEventListener('load', legacyGlobal.onLoadActions);
		window.addEventListener('unload', legacyGlobal.onUnloadActions);

		legacyGlobal.prepareBlinkingTitle();
	},

	onUnloadActions: function() {
		legacyGlobal.toplevelElement = null;
		legacyGlobal.currentlyActiveTabPopup = null;
		legacyGlobal.tagCloud = null;
		legacyGlobal.searchableList = null;
		window.removeEventListener('unload', legacyGlobal.onUnloadActions);
	},

	prepareBlinkingTitle: function() {
		document.addEventListener('blur', legacyGlobal.onBlur);
		document.addEventListener('focus', legacyGlobal.onFocus);
		if (legacyGlobal.isIE) {
			document.onfocusin = legacyGlobal.onFocus;
			document.onfocusout = legacyGlobal.onBlur;
		}
		legacyGlobal.oldTitle = document.title;
	},

	onBlur: function(ev) {
		legacyGlobal.isBackground = true;
	},

	onFocus: function(ev) {
		legacyGlobal.isBackground = false;
	},

	blinkTitle: function() {
		if (!legacyGlobal.isBackground) {
			if (typeof(legacyGlobal.oldTitle) != 'undefined')
				document.title = legacyGlobal.oldTitle;
			return;
		}
		var title = document.title;
		title = title.substr(1) + title.substr(0, 1);
		document.title = title;

		window.setTimeout(legacyGlobal.blinkTitle, 100);
	},

	registerTagSearchableList: function(el) {
		legacyGlobal.searchableList = el;
	},

	findTagSearchableList: function(el) {
		return legacyGlobal.searchableList;
	},

	registerTagCloud: function(el) {
		legacyGlobal.tagCloud = el;
	},

	findTagCloud: function(el) {
		return legacyGlobal.tagCloud;
	},

	hhmmss: function(secs) {
		time = [0, 0, secs];
		for (var i = 2; i > 0; i--) {
			time[i - 1] = Math.floor(time[i] / 60);
			time[i] = Math.round(time[i] % 60);
			if (time[i] < 10)
				time[i] = '0' + time[i];
		};
		return time.join(':')
	},

	mmss: function(secs) {
		time = [0, secs];
		for (var i = 1; i > 0; i--) {
			time[i - 1] = Math.floor(time[i] / 60);
			time[i] = Math.round(time[i] % 60);
			if (time[i] < 10)
				time[i] = '0' + time[i];
		};
		return time.join(':')
	},

	isTouchDevice: function() {
		return Boolean(window.ontouchstart || navigator.maxTouchPoints);
	},

	hasMouseSupport: function() {
		// https://stackoverflow.com/a/50687322
		return matchMedia('(pointer:fine)').matches;
	},
};

jQuery(document).ready(legacyGlobal.DOMReadyActions);
window.addEventListener('load', legacyGlobal.onLoadActions);

//Find current portal
document.querySelectorAll('head meta').forEach((meta) => {
	if (meta.getAttribute('name') == 'portal') {
		legacyGlobal.portal = meta.getAttribute('content');
	}
});
